import {
  Box,
  Button,
  Chip,
  CircularProgress,
  FormControl,
  FormControlLabel,
  Grid,
  InputLabel,
  MenuItem,
  Modal,
  OutlinedInput,
  Radio,
  RadioGroup,
  Select,
  SelectChangeEvent,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import img from "./assets/images/logo-ikes.png";
import { bg } from "date-fns/locale";
import { createClub, getListClub, uploadMedia } from "./service";
import ListClub from "./components/ListClub";
import { getCookie } from "utils/setCookie";
import CustomSnackbar from "components/snackbar";
const Club = () => {
  const [clubs, setClubs] = useState<any[]>([]);
  const [openCreateClub, setOpenCreateClub] = useState(false);
  const [cover, setCover] = useState<string>("");
  const [uploadingCover, setUploadingCover] = useState<boolean>(false);
  const [clubName, setClubName] = useState("");
  const [isEliteClub, setIsEliteClub] = useState(false);
  const [uploadingFeatured, setUploadingFeatured] = useState<boolean>(false);
  const [featuredImage, setFeaturedImage] = useState<
    { id: string; src: string }[]
  >([]);
  const [selectedCategories, setSelectedCategories] = useState<string[]>([]);
  const [description, setDescription] = useState("");
  const [loading, setLoading] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState<"success" | "error">(
    "success"
  );

  const fileInputRefCover = useRef<HTMLInputElement | null>(null);
  const fileInputRefFeatured = useRef<HTMLInputElement | null>(null);

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const fetchClubs = async () => {
    try {
      const data = await getListClub();
      setClubs(data);
    } catch (error) {
      console.error("Error fetching clubs:", error);
    }
  };

  useEffect(() => {
    fetchClubs();
  }, []);

  const handleClickOpen = () => {
    setClubName("");
    setCover("");
    setDescription("");
    setIsEliteClub(false);
    setSelectedCategories([]);
    setFeaturedImage([]);

    setOpenCreateClub(true);
  };

  const handleClose = () => {
    setOpenCreateClub(false);
  };

  const handleFileChange = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const file = event.target.files?.[0];
    if (!file) return;

    setUploadingCover(true);
    try {
      const headers = {
        "X-Authorization": getCookie("session"),
      };
      const response = await uploadMedia(file, headers);
      setCover(response.src);
      // toast.success("Upload image success!");
      setSnackbarMessage(`Tải ảnh lên thành công`);
      setSnackbarSeverity("success");
      setSnackbarOpen(true);
    } catch (error) {
      // toast.error("Upload failed:", error);
      setSnackbarMessage(`Tải ảnh lên thất bại!`);
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    } finally {
      setUploadingCover(false);
    }
  };

  const handleFileChangeFeatured = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const files = event.target.files;

    if (!files || files.length === 0) return;

    setUploadingFeatured(true);

    const headers = {
      "X-Authorization": getCookie("session"),
    };

    try {
      const uploadPromises = Array.from(files).map(async (file) => {
        const response = await uploadMedia(file, headers);
        return { id: response.id, src: response.src };
      });

      const uploadedImages = await Promise.all(uploadPromises);

      setFeaturedImage((prev) => [...prev, ...uploadedImages]);

      setSnackbarMessage(`Tải ảnh lên thành công`);
      setSnackbarSeverity("success");
      setSnackbarOpen(true);
    } catch (error) {
      setSnackbarMessage(`Tải ảnh lên thất bại!`);
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    } finally {
      setUploadingFeatured(false);
    }
  };

  const handleDeleteFeaturedImage = (id: string) => {
    setFeaturedImage((prev) => prev.filter((image) => image.id !== id));
  };

  const handleChangeCategories = (event: SelectChangeEvent<string[]>) => {
    const selected = event.target.value;

    if (Array.isArray(selected)) {
      if (selected.includes("All skills")) {
        setSelectedCategories(["All skills"]);
      } else {
        setSelectedCategories(selected);
      }
    }
  };

  const handleDeleteCategory = (category: string) => {
    setSelectedCategories((prevSelected) =>
      prevSelected.filter((item) => item !== category)
    );
  };

  const handleCreateClub = async () => {
    if (!clubName.trim()) {
      // toast.warning('Club Name is required!');
      console.log("Club Name is required!");
      setSnackbarMessage(`Không được bỏ trống trường đặt tên!`);
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
      return;
    }
    setLoading(true);
    try {
      await createClub(
        clubName,
        cover || "",
        description,
        isEliteClub,
        selectedCategories,
        featuredImage.map((item) => item.src),
        ""
      );
      // toast.success("Club created successfully!");
      setSnackbarMessage(`Tạo câu lạc bộ thành công!`);
      setSnackbarSeverity("success");
      setSnackbarOpen(true);
      await fetchClubs();
      handleClose();
    } catch (error) {
      // toast.error("Failed to create club. Please try again.");
      setSnackbarMessage(`Tạo câu lạc bộ thất bại.`);
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        width: "100%",
        maxWidth: "1450px",
        margin: "0 auto",
        padding: 2,
      }}
    >
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Typography variant="h5" fontWeight={550}>
          Danh sách Câu lạc bộ
        </Typography>
        <Button
          variant="contained"
          onClick={handleClickOpen}
          sx={{
            bgcolor: "#B32519",
            "&:hover": {
              bgcolor: "#B32519",
            },
          }}
        >
          Thêm câu lạc bộ
        </Button>
      </Stack>
      <ListClub
        clubs={clubs}
        placeholderImage={img}
        fetchClubs={fetchClubs}
        setSnackbarMessage={setSnackbarMessage}
        setSnackbarSeverity={setSnackbarSeverity}
        setSnackbarOpen={setSnackbarOpen}
        handleSnackbarClose={handleSnackbarClose}
      />
      ;
      <Modal
        open={openCreateClub}
        onClose={handleClose}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
      >
        <Box
          sx={{
            position: "absolute" as const,
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "100%",
            height: 700,
            overflowY: "auto",
            maxWidth: 500,
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 2,
            borderRadius: 2,
          }}
        >
          <Stack spacing={2}>
            <Typography
              id="modal-title"
              variant="h6"
              component="h2"
              fontWeight={550}
            >
              Tạo câu lạc bộ
            </Typography>

            <Stack
              direction="row"
              alignItems="center"
              justifyContent="center"
              gap={1}
            >
              <Box
                sx={{
                  position: "relative",
                  width: "100%",
                  maxWidth: 150,
                  height: "150px",
                  cursor: "pointer",
                }}
                onClick={() => {
                  if (fileInputRefCover.current) {
                    fileInputRefCover.current.click();
                  }
                }}
              >
                <Box
                  sx={{
                    width: "100%",
                    height: "100%",
                    border: cover.length > 0 ? "none" : "2px dashed #ccc",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    borderRadius: "8px",
                    backgroundColor: "#cfcfcf",
                    transition: "background-color 0.3s",
                    "&:hover": {
                      backgroundColor:
                        cover.length > 0 ? "rgba(0, 0, 0, 0.5)" : "#f1f1f1",
                    },
                  }}
                >
                  {uploadingCover ? (
                    <CircularProgress size={24} />
                  ) : (
                    <>
                      {cover.length > 0 ? (
                        <Box
                          sx={{
                            position: "relative",
                            width: "100%",
                            height: "100%",
                            borderRadius: "8px",
                            overflow: "hidden",
                          }}
                        >
                          <img
                            src={cover}
                            alt={`Uploaded ${cover}`}
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "contain",
                              borderRadius: "8px",
                            }}
                          />
                        </Box>
                      ) : (
                        <Typography variant="body1" color="textSecondary">
                          Thêm hình ảnh
                        </Typography>
                      )}
                    </>
                  )}
                  <input
                    ref={fileInputRefCover}
                    type="file"
                    style={{ display: "none" }}
                    onChange={handleFileChange}
                  />
                </Box>
              </Box>
            </Stack>

            <TextField
              label="Tên câu lạc bộ"
              variant="outlined"
              fullWidth
              required
              value={clubName}
              error={!clubName.trim()}
              onChange={(e) => setClubName(e.target.value)}
            />

            <Box pl={1}>
              <RadioGroup
                aria-labelledby="demo-radio-buttons-group-label"
                value={isEliteClub ? "elite" : "free"}
                name="radio-buttons-group"
                onChange={(e) => setIsEliteClub(e.target.value === "elite")}
              >
                <Stack direction="row" alignItems="center" gap={2}>
                  <FormControlLabel
                    value="free"
                    control={<Radio />}
                    label="Miễn phí"
                  />
                  <FormControlLabel
                    value="elite"
                    control={<Radio />}
                    label="Elite Club"
                  />
                </Stack>
              </RadioGroup>
            </Box>

            <Box
              sx={{
                position: "relative",
                width: "100%",
                height: "auto",
                cursor: "pointer",
              }}
              onClick={() => {
                if (fileInputRefFeatured.current) {
                  fileInputRefFeatured.current.click();
                }
              }}
            >
              <Box
                sx={{
                  width: "100%",
                  minHeight: "40px",
                  border: "2px dashed #ccc",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  borderRadius: "8px",
                  backgroundColor: "#cfcfcf",
                  transition: "background-color 0.3s",
                  "&:hover": {
                    backgroundColor: "#f1f1f1",
                  },
                }}
              >
                {uploadingFeatured ? (
                  <CircularProgress size={24} />
                ) : (
                  <>
                    <Typography variant="body1" color="textSecondary">
                      Thêm nhiều hình ảnh
                    </Typography>
                  </>
                )}
                <input
                  ref={fileInputRefFeatured}
                  type="file"
                  multiple
                  style={{ display: "none" }}
                  onChange={handleFileChangeFeatured}
                />
              </Box>

              {/* Hiển thị danh sách ảnh */}
              <Grid container spacing={2} sx={{ mt: 2 }}>
                {featuredImage.map((item, index) => (
                  <Grid item xs={4} sm={3} md={3} key={item.id}>
                    <Box
                      sx={{
                        position: "relative",
                        width: "100%",
                        height: "100px",
                        borderRadius: "8px",
                        overflow: "hidden",
                      }}
                    >
                      <img
                        src={item.src}
                        alt={`Uploaded ${index}`}
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                          borderRadius: "8px",
                        }}
                      />
                      <Box
                        sx={{
                          position: "absolute",
                          top: 4,
                          right: 4,
                          backgroundColor: "rgba(0, 0, 0, 0.5)",
                          borderRadius: "50%",
                          padding: "4px",
                          cursor: "pointer",
                        }}
                        onClick={(e) => {
                          e.stopPropagation();
                          handleDeleteFeaturedImage(item.id);
                        }}
                      >
                        <Typography variant="body2" color="error">
                          ✕
                        </Typography>
                      </Box>
                    </Box>
                  </Grid>
                ))}
              </Grid>
            </Box>

            <FormControl fullWidth>
              <InputLabel id="select-multiple-label">Thể loại</InputLabel>
              <Select
                multiple
                value={selectedCategories}
                onChange={handleChangeCategories}
                input={<OutlinedInput label="Thể loại" />}
                renderValue={(selected) => (
                  <div
                    style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}
                  >
                    {(selected as string[]).map((value) => (
                      <Chip key={value} label={value} />
                    ))}
                  </div>
                )}
              >
                <MenuItem
                  value="Career Guidance"
                  disabled={selectedCategories.includes("All skills")}
                >
                  Career Guidance
                </MenuItem>
                <MenuItem
                  value="Life"
                  disabled={selectedCategories.includes("All skills")}
                >
                  Life
                </MenuItem>
                <MenuItem
                  value="Finance"
                  disabled={selectedCategories.includes("All skills")}
                >
                  Finance
                </MenuItem>
                <MenuItem
                  value="Health"
                  disabled={selectedCategories.includes("All skills")}
                >
                  Health
                </MenuItem>
                <MenuItem
                  value="Business"
                  disabled={selectedCategories.includes("All skills")}
                >
                  Business
                </MenuItem>
              </Select>
            </FormControl>

            <TextField
              label="Mô tả"
              variant="outlined"
              fullWidth
              multiline
              rows={3}
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />

            <Stack direction="row" spacing={2} justifyContent="flex-end">
              <Button variant="outlined" onClick={handleClose}>
                Thoát
              </Button>
              <Button
                variant="contained"
                color="primary"
                onClick={handleCreateClub}
                disabled={loading}
                sx={{
                  bgcolor: "#B32519",
                  "&:hover": {
                    bgcolor: "#B32519",
                  },
                }}
              >
                {loading ? `Đang tạo....` : `Tạo câu lạc bộ`}
              </Button>
            </Stack>
          </Stack>
        </Box>
      </Modal>
      <CustomSnackbar
        open={snackbarOpen}
        message={snackbarMessage}
        severity={snackbarSeverity}
        onClose={handleSnackbarClose}
      />
    </Box>
  );
};

export default Club;
